import { createFileRoute } from '@tanstack/react-router'
import { PayslipsPage } from '@/features/employee-portal/pages/PayslipsPage'

export const Route = createFileRoute('/employee/payslips/')({
  component: PayslipsPage,
})
